
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/samenvattingen/[slug]",
      function () {
        return require("private-next-pages/samenvattingen/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/samenvattingen/[slug]"])
      });
    }
  